module.exports = __webpack_public_path__ + "img/tz_sheep2.15f9e73b.png";